import { useAuth } from '@ocula/auth';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { PageSpinner } from '@src/components/Spinner';

export function AuthenticatedInterstitial() {
  const { isAuthenticated, organisations } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login.
    return <Navigate to="login" state={{ from: location }} replace />;
  }

  // Wait for the authorisation data to be retrieved.
  if (!organisations.length) {
    return <PageSpinner />;
  }

  return <Outlet />;
}
